import { Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getWishListApi } from "../../Features/WishList/WishList";
import { getSearchProductApi } from "../../Features/Product/Product";

import styles from "./index.module.scss";
import { ProductCard } from "../../Component/productCard";

function SearchData() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userToken = useSelector((state) => state.user?.token);
  const userId = useSelector((state) => state.user?.userId);
  const filterList = useSelector((state) => state.product?.filterList);
  const loader = useSelector((state) => state.product?.productLoading);

  useEffect(() => {
    dispatch(getWishListApi(userToken));
    // Arriving here cold — a bookmark, a refresh, a shared link — there is nothing
    // in Redux to show, because the results are put there by the header as you
    // type. Re-run the last search the customer actually made rather than
    // leaving them on an empty page. The header used to cover this by searching
    // on every page load, for the literal string "undefined".
    if (!filterList?.length) {
      let last = "";
      try { last = localStorage.getItem("tdc_last_search") || ""; } catch (_) {}
      if (last.trim()) dispatch(getSearchProductApi(last, userId || 0, () => {}));
    }
    window.scrollTo(0, 0);
  }, []);

  const openMobileSearch = () => {
    // Trigger the mobile search overlay by dispatching a custom event
    window.dispatchEvent(new CustomEvent("openMobileSearch"));
  };

  return (
    <div className={styles.searchPage}>
      {loader ? (
        <div className={styles.loadingWrap}>
          <Spin size="large" />
        </div>
      ) : filterList?.length > 0 ? (
        <div className={styles.container}>
          <div className={styles.resultBar}>
            <span className={styles.resultCount}>
              {filterList.length} {filterList.length === 1 ? "result" : "results"} found
            </span>
            <div className={styles.resultActions}>
              <button type="button" className={styles.editSearch} onClick={openMobileSearch}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
                Edit Search
              </button>
              <button type="button" className={styles.closeSearch} onClick={() => navigate("/")}>

                Close Search
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
          </div>
          <div className={styles.productGrid}>
            {filterList.map((item, index) => (
              <ProductCard key={item?._id || index} item={item} />
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
          <h2 className={styles.emptyTitle}>No Results Found</h2>
          <p className={styles.emptyDesc}>Try searching with different keywords.</p>
          <button
            type="button"
            className={styles.emptyBtn}
            onClick={() => navigate("/")}
          >
            Back to Home
          </button>
        </div>
      )}
    </div>
  );
}

export default SearchData;
